import React, { useContext } from "react";
import { UserContext } from "../../routes/routes";
import SubHeader from "../subheader/Subheader";
import Header from "../header/Header";

const SubscriptionPlan: React.FC = () => {
  const { appContextdata } = useContext<any>(UserContext);

  return (
    <>
      <Header />
      <SubHeader />
      <div>
        <br />
        <h2>Subscription Plan Details</h2>
        <p>
          <strong>Plan ID:</strong> {appContextdata?.PlanId}
        </p>
        <p>
          <strong>Plan Name:</strong> {appContextdata?.PlanName}
        </p>
        <p>
          <strong>Is Subscription Active:</strong>{" "}
          {appContextdata?.IsSubscriptionActive ? "Yes" : "No"}
        </p>
        <p>
          <strong>Survey Count:</strong> {appContextdata?.SurveyCount}
        </p>
        <p>
          <strong>User Count:</strong> {appContextdata?.UserCount}
        </p>
        <p>
          <strong>Report Feature Enabled:</strong>{" "}
          {appContextdata?.Report ? "Yes" : "No"}
        </p>
      </div>
    </>
  );
};

export default SubscriptionPlan;
